// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf655fc1","239":"95b3f036","732":"5c1296f3"}[chunkId] + ".chunk.js";
};